import React, { useRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { ReactComponent as CancelIcon } from '../../../../assets/images/icons/circle-cancel.svg'
import { ReactComponent as ApplyIcon } from '../../../../assets/images/icons/circle-apply.svg'

import InputRange from '../../../Common/InputRange/InputRange'
import { Filters } from '../../../../helpers/adjust'
 
import Tooltip from '../../../Tooltip/Tooltip'

import './Filter.scss'

const Filter = ({
  type: { id, label, name, min, max },
  value,
  bg,
  isActive,
  onActivate,
  onDeactivate,
  onApply,
  onChange,
}) => {
  const canvasRef = useRef(null)
  const width = 224
  const height = 144

  useEffect(() => {
    // resize the image first
    const widthRatio = bg.width / width
    const heightRatio = bg.height / height
    let sx
    let sy
    let sWidth
    let sHeight

    if (widthRatio < heightRatio) { // fit by width
      sWidth = bg.width
      sx = 0

      sHeight = Math.round(widthRatio * height)
      sy = Math.round((bg.height - sHeight) / 2)
    } else if (heightRatio < widthRatio) { // fit by height
      sHeight = bg.height
      sy = 0

      sWidth = Math.round(heightRatio * width)
      sx = Math.round((bg.width - sWidth) / 2)
    }

    const ctx = canvasRef.current.getContext('2d')
    ctx.drawImage(bg, sx, sy, sWidth, sHeight, 0, 0, width, height)

    // than apply the filter
    const imageData = ctx.getImageData(0, 0, width, height)

    Filters.applyFilter(name, max, imageData)
    ctx.putImageData(imageData, 0, 0)
  }, [name, max, bg])

  const onChangeHandler = useCallback((value) => {
    onChange(value, name, id)
  }, [name, id, onChange])

  return (
    <div className={clsx('filter', {'filter_active': isActive, 'filter_activated': !!value })}>
      <div className="filter__name">{label}</div>
      <div
        className="filter__image"
        onClick={() => !isActive && onActivate(name, id)}
      >
        <canvas
          width={width}
          height={height}
          ref={canvasRef}
        />
        {isActive && (
          <React.Fragment>
            <div className="filter__buttons">
              <Tooltip
                placement="bottomRight"
                translationKey="titles.cancel"
              >
                <span 
                  className="filter__button" 
                  onClick={() => onDeactivate(name, id)}
                >
                  <CancelIcon />
                </span>
              </Tooltip>
              <Tooltip
                placement="bottomLeft"
                translationKey="titles.apply"
              >
                <span 
                  className="filter__button" 
                  onClick={() => onApply(name, id)}
                >
                  <ApplyIcon />
                </span>
              </Tooltip>
            </div>
            <InputRange
              min={min}
              max={max}
              roundBy={1}
              value={value}
              onChange={onChangeHandler}
              onClick={onChangeHandler}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

Filter.propTypes = {
  type: PropTypes.object.isRequired,
  value: PropTypes.number.isRequired,
  bg: PropTypes.instanceOf(HTMLCanvasElement).isRequired,
  isActive: PropTypes.bool.isRequired,
  onActivate: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Filter
